import * as yup from 'yup';

export const sharedValidation = {
  title: yup.string().min(5, 'Минимальное количество символов = 5').required('Обязательное поле.'),
};
